/**
 * Dane dodatkowe wymagane/akceptowane przez generator MF.
 * Odpowiada `AdditionalDataTypes` z `@akmf/ksef-fe-invoice-converter`,
 * zadeklarowane tutaj, by nie zależeć od wewnętrznych ścieżek typów upstreamu.
 */
export interface AdditionalData {
  /** Numer KSeF nadany fakturze. Wymagany przez generator. Dla podglądu roboczego podaj wartość zastępczą. */
  nrKSeF: string;
  /** Treść kodu QR (tryb offline). */
  qrCode?: string;
  /** Drugi kod QR (certyfikat wystawcy). */
  qr2Code?: string;
  /** Układ mobilny. */
  isMobile?: boolean;
  /** Znak wodny, np. "PODGLĄD" / "OFFLINE". */
  watermark?: string;
}

/** Cokolwiek, z czego potrafimy zrobić plik XML dla generatora. */
export type XmlInput = File | Blob | string;

/** Rodzaj dokumentu do wyrenderowania. */
export type DocumentKind = 'invoice' | 'upo';

/** Domyślne dane dla podglądu faktury jeszcze niewysłanej do KSeF. */
export const PREVIEW_DEFAULTS: AdditionalData = {
  nrKSeF: 'PODGLĄD',
  watermark: 'PODGLĄD',
};
